import layout from '@/components/common/layout';
import schoolList from '../views/school/list';
import schoolCreate from "../views/school/create";

export default [
    {
        path: '/school',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "学校列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'school_list',// 子选项
                    }
                },
                component: schoolList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增学校",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'school_list',// 子选项
                    }
                },
                component: schoolCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑学校",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'school_list',// 子选项
                    }
                },
                component: schoolCreate,
            },
        ]
    },
];
